import React from 'react';

const ArrowLeftIcon = ({ stroke = '#3E3E40', ...props }) => {
  return (
    <svg width="6" height="9" viewBox="0 0 6 9" {...props}>
      <path
        d="M4.49597 8.14625L0.874023 4.5243L4.49597 0.902344"
        stroke={stroke}
        fill="none"
        strokeWidth="1.20732"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowLeftIcon;
